export default __webpack_public_path__ + "static/media/Fifteen.92cac6fa.svg";